// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormFooter_wrapper__SSPNL","wrapper__link":"FormFooter_wrapper__link__KDUQq"};